/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { triggersDelete } from "../funcs/triggersDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteTriggerInstanceRequest,
  DeleteTriggerInstanceSecurity,
} from "../models/operations/deletetriggerinstance.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteTriggerMutationVariables = {
  request: DeleteTriggerInstanceRequest;
  security?: DeleteTriggerInstanceSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteTriggerMutationData = void;

export type DeleteTriggerMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteTriggerInstance triggers
 *
 * @remarks
 * Delete a trigger instance.
 */
export function useDeleteTriggerMutation(
  options?: MutationHookOptions<
    DeleteTriggerMutationData,
    DeleteTriggerMutationError,
    DeleteTriggerMutationVariables
  >,
): UseMutationResult<
  DeleteTriggerMutationData,
  DeleteTriggerMutationError,
  DeleteTriggerMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteTriggerMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteTrigger(): MutationKey {
  return ["@gram/client", "triggers", "delete"];
}

export function buildDeleteTriggerMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteTriggerMutationVariables,
  ) => Promise<DeleteTriggerMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteTrigger(),
    mutationFn: function deleteTriggerMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteTriggerMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(triggersDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
